// ═══════════════════════════════════════════════════════════════════════════
// Punto de entrada
//
// Sustituye al ReactDOM.createRoot(...) que vivía al final de index.html.
// jsPDF y pdf.js siguen llegando por CDN, como hoy: los módulos de PDF leen
// window.jspdf. Empaquetarlos sería un cambio de comportamiento y la Etapa 2
// no los admite.
// ═══════════════════════════════════════════════════════════════════════════

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.jsx";
import { Guardia } from "./auth/Guardia.jsx";
import { instalarMapas } from "./dominio/precios.js";
import { VINOPREMIER_PRICES, SACACORCHOS_PRICES } from "./config/semilla.js";

// Los mapas de precio eran constantes del código. Ahora se inyectan: en la
// Etapa 4 vendrán de la base sin tocar la lógica de precios.
instalarMapas({ vinopremier: VINOPREMIER_PRICES, sacacorchos: SACACORCHOS_PRICES });

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Guardia>
      {({ sesion, membresia }) => <App sesion={sesion} membresia={membresia} />}
    </Guardia>
  </React.StrictMode>
);
